import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  ISubscribeSuperCityResponse,
  ISubscribeSuperCityPayload,
} from "models/patients/subscribeSuperCity";
import { httpStatus } from "configs/httpStatus";
import { subcribePatient } from "services/patients";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./subscribeSuperCityActions";

function* subscribeSuperCitySaga({
  payload,
}: {
  payload: ISubscribeSuperCityPayload;
}) {
  try {
    const response: ISubscribeSuperCityResponse = yield call(
      subcribePatient,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else if (
      response.status === httpStatus.StatusUnauthorized ||
      response.status === httpStatus.StatusForbidden
    ) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSubscribeSuperCityWatcher() {
  yield takeLatest(
    ActionType.SUBSCRIBE_SUPER_CITY as any,
    subscribeSuperCitySaga
  );
}

export default [fork(onSubscribeSuperCityWatcher)];
